import { BuyDetails } from "./BuyDetails";
import { BuyTakeaway } from "./BuyTakeaway";
import { OtherFindings } from "./OtherFindings";
import { PurchaseLegend } from "./PurchaseLegend";
import { PurchaseTimeline } from "./PurchaseTimeline";
import type { SectionProps } from "./SectionProps";

// «Закуп»: ключевые предметы против сильных игроков (поздние, вовремя, не купленные),
// почему опоздали, защита и другие находки, метрики, все покупки — по кнопке.
// Разбор без ключевых предметов в подробностях — лента покупок по фазам, как раньше;
// без подробностей — только карточки находок.
export const BuySection = ({ report, findings }: SectionProps) => {
  const { details } = report;
  const heroId = report.match.hero_id;
  if (details === null || details.purchases.length === 0) {
    return <OtherFindings findings={findings} />;
  }
  if (details.core_build.length === 0) {
    return (
      <>
        <PurchaseLegend />
        <PurchaseTimeline purchases={details.purchases} heroId={heroId} />
        <BuyTakeaway findings={findings} heroId={heroId} />
        <OtherFindings findings={findings} shown={["item_bought_late"]} hasContent />
      </>
    );
  }
  return <BuyDetails details={details} findings={findings} heroId={heroId} />;
};
